/* eslint-disable no-new */
import { SUBTYPE_ENUM, VIDEO_SOURCES } from '../constants';
import { getCurrencySymbol } from './strings';
export var getPickerFormat = function getPickerFormat(subtype) {
  var format = 'dd/MM/yyyy HH:mm';
  if (subtype === SUBTYPE_ENUM.DATE) {
    format = 'dd/MM/yyyy';
  } else if (subtype === SUBTYPE_ENUM.TIME) {
    format = 'HH:mm';
  }
  return format;
};
export var scrollToWizardTop = function scrollToWizardTop() {
  var selector = "[id=\"opportunity-wizard-stepper\"]";
  var wizardElement = document.querySelector(selector);
  wizardElement.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export function roundToTwo(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}
export var calculatePercentage = function calculatePercentage(value, percentage) {
  return roundToTwo(value + value * (percentage / 100));
};
export var getPercentageValue = function getPercentageValue(value, percentage) {
  return roundToTwo(value * (percentage / 100));
};
export var getPaymentSummary = function getPaymentSummary(value, currency) {
  var service = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  var discount = arguments.length > 3 ? arguments[3] : undefined;
  var result = {
    currency: getCurrencySymbol(currency),
    fee: value
  };
  result.service = roundToTwo(getPercentageValue(value, service));
  result.discount = discount ? getPercentageValue(value + result.service, -discount) : 0;
  result.total = roundToTwo(value + result.service + result.discount);
  return result;
};
export var getVideoId = function getVideoId(link) {
  var result = false;
  try {
    new URL(link);
    VIDEO_SOURCES.forEach(function (source) {
      var match = link && link.match(source.regex);
      if (match && (match[source.result].length === source.resultLength || match[source.result].length === source.resultMaxLength)) {
        result = {
          type: source.type,
          value: match[source.result]
        };
      } else if (match) {
        result = {
          type: source.type,
          value: match[source.result]
        };
      }
    });

    // If it's not a YouTube or Vimeo link, return a generic video type
    if (!result && link) {
      result = {
        type: 'GENERIC',
        value: link
      };
    }
  } catch (err) {
    return result;
  }
  return result;
};
export var getHashParameter = function getHashParameter(link) {
  var regex = /\/(\w+)\?/;
  var match = regex.exec(link);
  return match ? match[1] : null;
};